import React from "react";
import { Grid, Typography } from "@mui/material";

import MuiInputField from "../../../../../../../Components/InputField/InputField";
import { TextView } from "../../../../../../../Components/TextView";
import InsuranceSelection from "../InsuranceSelectionTpa/InsuranceSelectionTpa";

function WorkingHours({
  isEditable,
  insuranceDetails,
  setInsuranceDetails,
  insurances,
  tpas,
  insuranceData,
}) {
  return (
    <Grid item lg={12}>
      <Grid item lg={12}>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "16px",

            paddingBottom: "20px",
            paddingTop: "20px",
          }}>
          Working Hours
        </Typography>
      </Grid>
      <Grid container item lg={3.8} justifyContent={"space-between"}>
        {isEditable ? (
          <>
            <Grid item lg={5.5}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                }}>
                Add Working Hours
              </Typography>
              <MuiInputField
                type="time"
                onChange={(e) =>
                  setInsuranceDetails((s) => ({
                    ...s,
                    fromWorkHr: e.target.value,
                  }))
                }
                value={insuranceDetails.fromWorkHr}
                placeHolder={"From"}
              />
            </Grid>
            <Grid item lg={5.5}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#f9fbfc",
                  paddingBottom: "7px",
                }}>
                Contact Person Name
              </Typography>

              <MuiInputField
                type="time"
                onChange={(e) => {
                  setInsuranceDetails((s) => ({
                    ...s,
                    toWorkHr: e.target.value,
                  }));
                }}
                value={insuranceDetails.toWorkHr}
                placeHolder={"To"}
              />
            </Grid>
          </>
        ) : (
          <TextView>
            {insuranceData?.fromWorkHr} to {insuranceData?.toWorkHr}
          </TextView>
        )}
      </Grid>
      <InsuranceSelection
        isEditable={isEditable}
        insurances={insurances}
        insuranceDetails={insuranceDetails}
        tpas={tpas}
        insuranceData={insuranceData}
        setInsuranceDetails={setInsuranceDetails}
        {...insuranceDetails}
      />
    </Grid>
  );
}

export default WorkingHours;
